module.exports = __webpack_public_path__ + "static/media/Kanit-Bold.50a03518.ttf";